module.exports = __webpack_public_path__ + "img/B_ezplan4.ead848c5.png";